// @ts-strict-ignore
import { buttonLabel } from '../Typography/Text'
import { InputHasErrorProp } from './styles'
import { Flex } from '@gassan-ui'
import { rem } from 'polished'
import React, { FC, InputHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

const Label = styled.label`
  ${buttonLabel};
  transition: 0.2s ease-in-out all;
  display: block;
  color: ${(p) => p.theme.colors.shades[900]};
  padding: 0.25rem 0.5rem;
  left: 0;

  &::before {
    transition: 0.2s ease-in-out all;
    width: ${rem(14)};
    height: ${rem(14)};
    position: absolute;
    background-color: transparent;
    content: '';
    left: 0;
    top: 0.5rem;
    border: 1px solid ${(p) => p.theme.colors.shades[500]};
  }
`

const Input = styled.input<InputHasErrorProp>`
  opacity: 0;
  font-family: helvetica, 'sans-serif';

  ${(p) =>
    p.disabled
      ? // Disabled state
        css`
          + ${Label} {
            cursor: not-allowed;
            color: ${p.theme.colors.shades[500]};
          }
          + ${Label}::before {
            border-color: ${p.theme.colors.shades[300]};
            background-color: ${p.theme.colors.shades[100]};
          }
        `
      : p.hasError
      ? // Error state
        css`
          + ${Label} {
            cursor: pointer;
            color: ${p.theme.rolex.colors.red};
          }
          + ${Label}::before {
            border-color: ${p.theme.rolex.colors.red};
          }
        `
      : // Default state
        css`
          &:hover {
            + ${Label} {
              cursor: pointer;
              color: ${(p) => p.theme.rolex.colors.primary};
            }
            + ${Label}::before {
              border-color: ${p.theme.colors.shades[500]};
            }
          }
        `};

  &:checked {
    + ${Label}::before {
      background-color: ${(p) => p.theme.rolex.colors.primary};
      border-color: ${(p) => p.theme.rolex.colors.primary};
    }
  }
`

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode
  id?: string
  hasError?: boolean
}

export const Checkbox: FC<CheckboxProps> = ({ label, hasError, ...rest }) => {
  const id =
    rest.id ||
    rest.name ||
    `id-${[...Array(5)].map((i) => (~~(Math.random() * 36)).toString(36)).join('')}`

  return (
    <Flex position="relative" alignItems="flex-start">
      <Input
        data-field-id={rest.name}
        type="checkbox"
        id={id}
        {...rest}
        hasError={hasError}
      ></Input>
      <Label htmlFor={id}>{label}</Label>
    </Flex>
  )
}
